/**
 * AN ASK OUTLIVES ITS SHEET. A sheet can be closed at any moment, the moment a request is out
 * included, so what it takes to ask once is held by the place the sheet opens over, Schedule for a
 * visit and Home for a home, and never by the sheet:
 *
 * - WHETHER A REQUEST IS OUT, so a tap does nothing while one is, in this sheet or in one opened
 *   again on the same visit or home.
 * - THE KEY MINTED FOR EACH ANSWER, so a retry after a failure, from this sheet or one opened again,
 *   names the same request and the door writes one row. The keys are let go once the door has
 *   written a request, so what is asked after that is a new request.
 *
 * What the door answers is the place's to act on however long it takes: a request written after the
 * sheet has closed is still said to be sent, and the place is still read again.
 */

/** What one visit's or one home's asking holds, for as long as the place is shown. */
export interface Asking {
  /** A request is out. */
  out: boolean;
  /** The key minted for each answer, by the answer. */
  readonly keys: Map<string, string>;
}

/** The asking held for one visit or home, made the first time it is needed. */
export function askingFor(held: Map<string, Asking>, id: string): Asking {
  let asking = held.get(id);
  if (asking === undefined) {
    asking = { out: false, keys: new Map() };
    held.set(id, asking);
  }
  return asking;
}

/** The key for this answer: the one minted for it before, or a new one. */
export function keyFor(asking: Asking, answer: string): string {
  let key = asking.keys.get(answer);
  if (key === undefined) {
    key = crypto.randomUUID();
    asking.keys.set(answer, key);
  }
  return key;
}
